export default __webpack_public_path__ + "static/media/Happy Bites - Dog Biscuits.47001c99.png";